export default function updateFormValue(form, field, value) {
  const formObject = document.forms[form];
  const formElement = formObject.elements[field];

  if (typeof formElement !== 'undefined') {
    formElement.value = value;
  }
}
